/* Number 6 Books v2: cart drawer, quick add, add-both, sticky buy bar. No dependencies. */
(function () {
  'use strict';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var drawer = document.querySelector('[data-cart-drawer]');
  var lastFocus = null;

  function toast(text) {
    var el = document.querySelector('.n6-toast');
    if (!el) { el = document.createElement('div'); el.className = 'n6-toast'; el.setAttribute('role', 'status'); document.body.appendChild(el); }
    el.textContent = text;
    el.classList.add('is-visible');
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.classList.remove('is-visible'); }, 2600);
  }

  function setCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function refreshDrawer() {
    return fetch(root + '?sections=cart-drawer', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data && data['cart-drawer'];
        if (!html || !drawer) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-drawer-inner]');
        var current = drawer.querySelector('[data-cart-drawer-inner]');
        if (fresh && current) current.replaceWith(fresh);
        var c = doc.querySelector('[data-cart-total-count]');
        if (c) setCount(parseInt(c.getAttribute('data-cart-total-count'), 10) || 0);
      });
  }

  function openDrawer() {
    if (!drawer) { window.location.href = root + 'cart'; return; }
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('n6-locked');
    var panel = drawer.querySelector('.n6-drawer-cart__panel');
    if (panel) setTimeout(function () { panel.focus(); }, 50);
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('n6-locked');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function addItems(payload, button) {
    if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }
    var isForm = payload instanceof FormData;
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: isForm ? { Accept: 'application/json' } : { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: isForm ? payload : JSON.stringify(payload)
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { return refreshDrawer(); })
      .then(function () { openDrawer(); })
      .catch(function (err) { toast((err && (err.description || err.message)) || 'That didn’t go through. Try again.'); })
      .finally(function () { if (button) { button.disabled = false; button.removeAttribute('aria-busy'); } });
  }

  // Add-to-cart forms (book page form and quick-add forms)
  document.addEventListener('submit', function (event) {
    var form = event.target.closest('form[data-add-to-cart], form[action$="/cart/add"]');
    if (!form || !window.fetch) return;
    event.preventDefault();
    addItems(new FormData(form), form.querySelector('[type="submit"]'));
  });

  // Add several books at once: data-add-items='[{"id":123,"quantity":1}]'
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-add-items]');
    if (btn) {
      event.preventDefault();
      try { addItems({ items: JSON.parse(btn.getAttribute('data-add-items')) }, btn); } catch (e) { /* noop */ }
      return;
    }
    if (event.target.closest('[data-cart-open]') && drawer) { event.preventDefault(); openDrawer(); return; }
    if (event.target.closest('[data-cart-close]')) { event.preventDefault(); closeDrawer(); return; }
    var change = event.target.closest('[data-cart-line]');
    if (change) {
      event.preventDefault();
      fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: parseInt(change.getAttribute('data-cart-line'), 10), quantity: parseInt(change.getAttribute('data-cart-qty'), 10) })
      }).then(refreshDrawer);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && drawer && drawer.classList.contains('is-open')) closeDrawer();
  });

  // Sticky buy bar on book pages
  var sticky = document.querySelector('[data-sticky-buy]');
  var anchor = document.querySelector('[data-buy-anchor]');
  if (sticky && anchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var past = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', past);
        sticky.setAttribute('aria-hidden', past ? 'false' : 'true');
      });
    }, { threshold: 0 }).observe(anchor);
  }
})();
